import React from 'react'
import { Link, useParams } from 'react-router'

import InvalidOrExpiredCard from '@/components/misc/InvalidOrExpiredCard'
import { Button } from '@/components/ui/button'
import { Container } from '@/components/ui/container'
import { useAuth } from '@/hooks/useAuth'
import { useIsRoute } from '@/hooks/useIsRoute'
import { REFERRALS_TAB } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { REFERRAL_INVITE_PARAMS } from '@/pages/referralInvite/constants'

const ReferralInviteClaimedError: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const params = useParams()
  const referralId = params[REFERRAL_INVITE_PARAMS.referralId]
  const isRoute = useIsRoute()
  const isReferralInviteDetailPage =
    isRoute(ROUTES._referralInvite) && !!referralId

  const loginRoute = isReferralInviteDetailPage
    ? ROUTES.referralSummary({ params: { referralId: referralId } })
    : ROUTES.referrals({ searchParams: { tab: REFERRALS_TAB.received } })

  const referralTerm = isReferralInviteDetailPage ? 'referral' : 'referrals'

  return (
    <div className="mx-auto mt-18 max-w-175 pb-12">
      <Container>
        <InvalidOrExpiredCard
          title="Link is no longer valid"
          className="max-w-5xl"
          content={
            <>
              <p className="mb-2">
                This invite link has already been claimed and is no longer
                valid.
              </p>

              {isAuthenticated ? (
                <>
                  <p className="mb-2">
                    If you previously claimed the invite, please try viewing the{' '}
                    {referralTerm} on RQ.
                  </p>

                  <Button asChild size="lg">
                    <Link to={loginRoute}>View {referralTerm} on RQ</Link>
                  </Button>
                </>
              ) : (
                <>
                  <p className="mb-4">
                    If you previously claimed the invite, please login to view
                    your {referralTerm}.
                  </p>

                  <Button asChild size="lg">
                    <Link to={loginRoute}>Login to RQ</Link>
                  </Button>
                </>
              )}
            </>
          }
        />
      </Container>
    </div>
  )
}

export default ReferralInviteClaimedError
